import openErrorBannerAction from 'modules/banner/actions/open-error'
import loadPreferencesAction from 'modules/training/modules/preferences/actions/load'
import savePreferencesAction from 'modules/training/modules/preferences/actions/save'
import { getCurrentPreferencesSelect } from 'modules/training/modules/preferences/selectors'
import updateAndValidateReduxAction from 'modules/redux/actions/update-and-validate'
import getPathReduxUtil from 'modules/redux/utils/get-path'
import { logUtil } from 'packages/src'
import { defineMessages } from 'react-intl'

const preferenceMessages = defineMessages({
  notFound: {
    id: 'preferences.notFound',
    defaultMessage: 'Preferences not found. Try to close and reopen the app. However, try to sign out then sign in again if this error persists.',
    description: 'The message displayed when the user tries to do an action that requires a server response.'
  }
})

function updatePreferencesAction (params) {
  return async (dispatch, getState) => {
    let preferences = getCurrentPreferencesSelect(getState())
    if (!preferences) {
      logUtil('').info('[not_found][load] preferences not found, load them')
      await dispatch(loadPreferencesAction())
    }

    preferences = getCurrentPreferencesSelect(getState())
    if (!preferences) {
      logUtil('').info('[not_found][load] preferences not found after load')
      dispatch(openErrorBannerAction({
        intlMessage: preferenceMessages.notFound
      }))
      return
    }

    const {
      payload,
      shouldNotSave
    } = params
    dispatch(updateAndValidateReduxAction({
      type: params.type,
      payload: {
        path: getPathReduxUtil(preferences), ...payload
      }
    }))
    if (!shouldNotSave) {
      dispatch(savePreferencesAction())
    }
  }
}

export default updatePreferencesAction
